import React from "react";
import { css } from "styled-components";
import { FontWeight, Spacing, form, inputDisabled, size } from "@glossy";

export type Checkable = {
  label?: React.ReactNode;
  checked?: boolean;
  disabled?: boolean;
  inline?: boolean;
  onClick?: (event: any, checked?: boolean) => void;
  className?: string;
  isVisible?: boolean;
};

export const checkable = {
  root: ({ checked, inline, disabled }: Partial<Checkable>) => css`
    display: ${inline && "inline-"}flex;
    justify-content: flex-start;
    align-items: flex-start;
    min-height: 22px;
    line-height: 22px;
    cursor: pointer;
    column-gap: ${Spacing.ExtraSmall};
    ${disabled && inputDisabled};
    font-weight: ${checked && FontWeight.Bold};
  `,
  box: ({ checked }: Partial<Checkable>) => css`
    display: flex;
    flex: none;
    align-items: center;
    justify-content: center;
    ${size(18)};
    border-width: ${checked ? 2 : 1}px;
    border-style: solid;
    border-color: ${(props) => form(props, checked ? "include" : "primary")};
    font-size: 0;
    line-height: 0;
    box-sizing: border-box;
    margin-top: 2px;
  `,
  label: css`
    overflow: hidden;
    text-overflow: ellipsis;
    user-select: none;
  `,
};
